import { createFileRoute } from '@tanstack/react-router'

import { AuthLayout } from '@/app/layouts'

/** Pathless layout for everything outside the guard: login, callback, errors. */
export const Route = createFileRoute('/_public')({
  component: AuthLayout,
})
